import { Newspaper } from '../../types';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, IconButton, Typography, Box, TextField, TablePagination
} from '@mui/material';
import { Edit, Delete, PictureAsPdf, Image } from '@mui/icons-material';

interface NewspapersTableProps {
  items: Newspaper[];
  loading: boolean;
  total: number;
  page: number;
  limit: number;
  onPageChange: (page: number) => void;
  onEdit: (item: Newspaper) => void;
  onDelete: (id: number) => void;
}

export function NewspapersTable({ items, loading, total, page, limit, onPageChange, onEdit, onDelete }: NewspapersTableProps) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Название</TableCell>
            <TableCell>Номер выпуска</TableCell>
            <TableCell>Год</TableCell>
            <TableCell>PDF</TableCell>
            <TableCell>Обложка</TableCell>
            <TableCell align="right">Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={6} align="center">
                <Typography>Загрузка...</Typography>
              </TableCell>
            </TableRow>
          ) : items.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} align="center">
                <Typography color="text.secondary">Нет записей</Typography>
              </TableCell>
            </TableRow>
          ) : (
            items.map((item) => (
              <TableRow key={item.id} hover>
                <TableCell>{item.title}</TableCell>
                <TableCell>{item.issueNumber || '—'}</TableCell>
                <TableCell>{item.year}</TableCell>
                <TableCell>
                  {item.pdfUrl ? (
                    <IconButton href={item.pdfUrl} target="_blank" size="small">
                      <PictureAsPdf />
                    </IconButton>
                  ) : '—'}
                </TableCell>
                <TableCell>
                  {item.coverUrl ? (
                    <IconButton href={item.coverUrl} target="_blank" size="small">
                      <Image />
                    </IconButton>
                  ) : '—'}
                </TableCell>
                <TableCell align="right">
                  <IconButton onClick={() => onEdit(item)} size="small">
                    <Edit />
                  </IconButton>
                  <IconButton onClick={() => onDelete(item.id)} size="small" color="error">
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={total}
        page={page - 1}
        onPageChange={(_, newPage) => onPageChange(newPage + 1)}
        rowsPerPage={limit}
        rowsPerPageOptions={[limit]}
      />
    </TableContainer>
  );
}

interface NewspapersToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  yearFilter?: number;
  onYearFilterChange: (value: number | undefined) => void;
}

export function NewspapersToolbar({ search, onSearchChange, yearFilter, onYearFilterChange }: NewspapersToolbarProps) {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
      <TextField
        label="Поиск"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        size="small"
        sx={{ minWidth: 200 }}
      />
      <TextField
        select
        label="Год"
        value={yearFilter || ''}
        onChange={(e) => onYearFilterChange(e.target.value ? parseInt(e.target.value) : undefined)}
        size="small"
        sx={{ minWidth: 120 }}
        SelectProps={{ native: true }}
      >
        <option value="">Все</option>
        {years.map((year) => (
          <option key={year} value={year}>{year}</option>
        ))}
      </TextField>
    </Box>
  );
}